import { FreeGameReelPanelControllerBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";

import { delayedCall, dispatcher, IEvent, ingenuity, killDelayedCall, SpineBase } from "@quest/base-core";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SymbolBase } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";

export class FreeGameReelPanelControllerGame extends FreeGameReelPanelControllerBehavior {
  private cascadeOnReelsCounter: number = 0;

  /**
   * subscribe all events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL_FG, this.updateGridStaticSymbolAfterMoney, this);
    dispatcher.on(eventDispatchers.FG_CASCADE_SPIN_COMPLETE, this.onFgCascadeSpinComplete, this);
    dispatcher.on(eventDispatchers.UDPATE_NEW_FG_REELSET, this.updateReelsets, this);
    dispatcher.on(eventDispatchers.SPECIAL_SYMBOL_OUT_ANIM_FG, this.playSpecialSymbolOutAnim, this);
    dispatcher.on(eventDispatchers.HIDE_SYMBOL_ON_REEL_FG, this.removeReelSymbols, this)
  }
  private removeReelSymbols(evt: IEvent): void {
    let reelId = evt.data[0];
    let col = evt.data[1] + gameConstants.OFFSET_INCREMENT_X5;
    this.reelView.getSymbolByPos(reelId, col).getStatic().visible = false;
    this.reelView.getSymbolByPos(reelId, col).getAnimation().visible = false;
  }
  /**
   * unsubscribe all events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL_FG, this.updateGridStaticSymbolAfterMoney, this);
    dispatcher.off(eventDispatchers.FG_CASCADE_SPIN_COMPLETE, this.onFgCascadeSpinComplete, this);
    dispatcher.off(eventDispatchers.UDPATE_NEW_FG_REELSET, this.updateReelsets);
    dispatcher.off(eventDispatchers.SPECIAL_SYMBOL_OUT_ANIM_FG, this.playSpecialSymbolOutAnim, this);
  }

  /**
   * This method is use to update reelsets
   */
  private updateReelsets() {
    this.reelView.getModel().setReelsets([(ingenuity.parserModel as GameParserModel).getFreeSpinReel()]);
  }

  private playSpecialSymbolOutAnim(): void {
    let trailData = (ingenuity.parserModel as GameParserModel).getSpecialSymbolData();
    trailData.forEach((data: any) => {
      this.playSymbolAnimation(data.offset, 'out');
      delayedCall('startSymbolTrail123' + data.offset, gameConstants.TIMER_500, () => {
        killDelayedCall('startSymbolTrail123' + data.offset);
        this.updateGridStaticSymbol(data.offset);
      })
    });
    delayedCall('startSymbolTrail', gameConstants.TIMER_500, () => {
      killDelayedCall('startSymbolTrail');
      dispatcher.fireEvent(eventDispatchers.START_SCATTER_TRAIL_FG);
    })
  }

  private updateGridStaticSymbol(offset: number[]): void {
    let reelId = offset[0];
    let col = offset[1] + gameConstants.OFFSET_INCREMENT_X5;
    let reelGrid = this.model.getReelGrid();
    let symbol = reelGrid[reelId][col]
    if (symbol == gameConstants.SPECIAL_SYMBOL_NOTE_ID) {
      reelGrid[reelId][col] = gameConstants.NOTE_BLANK_SYMBOL_ID;
    } else if (symbol == gameConstants.SPECIAL_SYMBOL_MAGNIFY_ID) {
      reelGrid[reelId][col] = gameConstants.MAGNIFY_BLANK_SYMBOL_ID;
    } else {
      reelGrid[reelId][col] = gameConstants.KEY_BLANK_SYMBOL_ID;
    }
    this.reelView.showStaticGrid(reelGrid);
    (ingenuity.parserModel as GameParserModel).setReelGrid(reelGrid);
    (ingenuity.parserModel as GameParserModel).setFreeGameReelSetWithStack(reelGrid);
    this.reelView.getSymbolByPos(reelId, col).getStatic().visible = true;
  }

  private updateGridStaticSymbolAfterMoney(evt: IEvent): void {
    let offset: number[] = evt.data.offset;
    let updatedSymbolId: number = evt.data.symbolId;
    let reelId = offset[0];
    let col = Number(offset[1]) + gameConstants.OFFSET_INCREMENT_X5;
    let reelGrid = this.model.getReelGrid();
    reelGrid[reelId][col] = updatedSymbolId;
    this.reelView.showStaticGrid(reelGrid);
    (ingenuity.parserModel as GameParserModel).setReelGrid(reelGrid);
    (ingenuity.parserModel as GameParserModel).setFreeGameReelSetWithStack(reelGrid);
    this.reelView.getSymbolByPos(reelId, col).getStatic().visible = true;
  }


  private playSymbolAnimation(offset: number[], animName: string): void {
    let symbol: SymbolBase = this.reelView.getSymbolByPos(offset[0], offset[1] + gameConstants.OFFSET_INCREMENT_X5);
    let staticSym = symbol.getStatic();
    let animSym: SpineBase = symbol.getAnimation() as SpineBase;
    staticSym.visible = false;
    this.reelView?.getAnimReels()[offset[0]].addChild(animSym);
    animSym.visible = true;
    setTimeout(() => {
      animSym.playAnim(animName, false);
      animSym.onComplete.addOnce(() => {
      })
    }, 1);
  }

  /**
   * This method is use to show win after cascading is completed
   */
  private onFgCascadeSpinComplete(): void {
    this.cascadeOnReelsCounter += 1;
    if (this.cascadeOnReelsCounter === (ingenuity.parserModel as GameParserModel).getCurrentCascadingReelNumber()) {
      this.cascadeOnReelsCounter = 0;
      const currenCascadeCount: number = (ingenuity.parserModel as GameParserModel).getCascadingCount();
      (ingenuity.parserModel as GameParserModel).setCascadingCount(currenCascadeCount - 1);
      if ((ingenuity.parserModel as GameParserModel).getCascadeWin()) {
        dispatcher.fireEvent(eventDispatchers.SHOW_CASCADE_WIN);
      } else {
        dispatcher.fireEvent(
          eventDispatchers.ON_CASCADE_COMPLETE_UPDATE_FS_BAR_RETRIGGER,
          (ingenuity.parserModel as GameParserModel).getTotalCascadeNumber()
        );
        // !this.model.getIsFgBigWin() && dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOTAL_WIN_MSG);
        dispatcher.fireEvent(SlotEventConstantsBehavior.CONSOLE_TOTAL_WIN_METER,
           ((ingenuity.parserModel as GameParserModel).getCurrentlyProcessingFSAmt() + (ingenuity.parserModel as GameParserModel).getTotalFgCascadeWin())
          )

      }
    }
  }
}
